import * as React from 'react';
import { SVGProps } from 'react';

const IconLaptopStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H4ZM23 18H1v2h22v-2Z" />
  </svg>
);
export default IconLaptopStrokedSizeM;
